"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBlockUserDto = instanceOfBlockUserDto;
exports.BlockUserDtoFromJSON = BlockUserDtoFromJSON;
exports.BlockUserDtoFromJSONTyped = BlockUserDtoFromJSONTyped;
exports.BlockUserDtoToJSON = BlockUserDtoToJSON;
exports.BlockUserDtoToJSONTyped = BlockUserDtoToJSONTyped;
/**
 * Check if a given object implements the BlockUserDto interface.
 */
function instanceOfBlockUserDto(value) {
    if (!('blocked' in value) || value['blocked'] === undefined)
        return false;
    return true;
}
function BlockUserDtoFromJSON(json) {
    return BlockUserDtoFromJSONTyped(json, false);
}
function BlockUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'blocked': json['blocked'],
        'blockReasonId': json['blockReasonId'] == null ? undefined : json['blockReasonId'],
        'customMessage': json['customMessage'] == null ? undefined : json['customMessage'],
    };
}
function BlockUserDtoToJSON(json) {
    return BlockUserDtoToJSONTyped(json, false);
}
function BlockUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'blocked': value['blocked'],
        'blockReasonId': value['blockReasonId'],
        'customMessage': value['customMessage'],
    };
}
